import React, { FC } from 'react';
import './styles.scss';

export const TalentListItemSkeleton: FC = () => {
  return (
    <div className="talent-pipeline-sidebar-list-item-skeleton">
      <div className="talent-pipeline-sidebar-list-item-skeleton__avatar-wrapper">
        <div className="talent-pipeline-sidebar-list-item-skeleton__avatar pulse-fade" />
      </div>

      <div className="talent-pipeline-sidebar-list-item-skeleton__info">
        <div className="talent-pipeline-sidebar-list-item-skeleton__line talent-pipeline-sidebar-list-item-skeleton__line--large pulse-fade" />

        <div className="talent-pipeline-sidebar-list-item-skeleton__line talent-pipeline-sidebar-list-item-skeleton__line--medium pulse-fade" />

        <div className="talent-pipeline-sidebar-list-item-skeleton__line talent-pipeline-sidebar-list-item-skeleton__line--small pulse-fade" />

        <div className="talent-pipeline-sidebar-list-item-skeleton__line talent-pipeline-sidebar-list-item-skeleton__line--large pulse-fade" />

        <div className="talent-pipeline-sidebar-list-item-skeleton__line talent-pipeline-sidebar-list-item-skeleton__line--small pulse-fade" />
      </div>
    </div>
  );
};
